import api from './api.js';

// The 6 rate articles (percent values), stable keys + RU labels for the panel.
export const RATE_ARTICLES = [
  { key: 'expertSalary', label: 'Зарплата экспертов' },
  { key: 'backofficeSalary', label: 'Зарплата бэкофис' },
  { key: 'overheadMain', label: 'Накладные_основные' },
  { key: 'overheadRun', label: 'Накладные_прогон' },
  { key: 'taxes', label: 'Налоги' },
  { key: 'commission', label: 'Комиссия' },
];

// bucket key for wirings that have no organisation filled in
export const FL_KEY = 'FL';
export const FL_LABEL = 'ФЛ (без организации)';

// -> [2025, 2024, ...] (desc), years that have a config row
export const getRateConfigYears = async () => {
  const res = await api.get('supmain/rateConfig');
  return (res.payload || [])
    .map((r) => r.year)
    .filter((y) => y != null)
    .sort((a, b) => b - a);
};

// -> { "<legalEntityId>" | "FL": { expertSalary: number, ... } }  (may be {})
export const getRateConfig = async (year) => {
  const res = await api.get(`supmain/rateConfig/${year}`);
  const raw = res.payload && res.payload.data;
  if (!raw) return {};
  try {
    return JSON.parse(raw) || {};
  } catch (e) {
    return {};
  }
};

// admin-only on the backend (@PreAuthorize hasRole ADMIN)
export const saveRateConfig = async (year, config) => {
  return api.putJson('supmain/rateConfig', { year, data: JSON.stringify(config) });
};

// look up one rate: orgId null/undefined -> the FL bucket. Returns a number or null.
export const rateOf = (config, orgId, articleKey) => {
  if (!config) return null;
  const bucket = config[orgId == null ? FL_KEY : String(orgId)];
  const v = bucket && bucket[articleKey];
  return typeof v === 'number' && !Number.isNaN(v) ? v : null;
};
